// extracted by mini-css-extract-plugin
export default {"container":"modal_container__LUhaP","head":"modal_head__rjDyB","btn_div":"modal_btn_div__cWJFl"};